import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import {
  generateBreadcrumbStructuredData,
  generateWebPageStructuredData,
} from "../../components/SEO/StructuredData";
import { aiAssistImport } from "../../utility/aiAssistCopy";

const page = aiAssistImport("recaps");

const DESCRIPTION =
  "Get games from paper recaps onto the board between squads. Print the recap, photograph the filled sheet, and put the games on the right team. Free on your first tournament, then AI Assist.";

const SECTIONS = [
  {
    title: "Retyping recaps costs you time and typos",
    body: "Between squads you get a stack of recap sheets. Typing every game by hand slows the next squad and puts wrong scores on the board.",
  },
  {
    title: "Print the recap, then photograph the filled sheet",
    body: "Print the recap for the team. After they bowl, photograph the filled sheet and upload it. The games land on that team.",
  },
  {
    title: "Side pots and standings use the same scores",
    body: "Once the games are on the team, you can correct a game if needed. Standings and side pots update from those same scores. You do not keep a second sheet for the house.",
  },
  {
    id: "plans",
    title: "Free on your first tournament",
    body: "Recap sheet import is free on your first tournament. After that it is part of AI Assist.",
    to: "/pricing",
    linkLabel: "Plans",
  },
];

const BowlingTournamentRecapSheetImport = () => (
  <ProductPage
    title={page.title}
    description={DESCRIPTION}
    keywords={[
      "AI recap sheet bowling",
      "bowling recap sheet scoring",
      "bowling tournament recap sheet import",
      "score sheet import",
      "AI Assist",
    ]}
    canonicalUrl="/bowling-tournament-recap-sheet-import"
    kicker="AI Assist"
    heading={page.heading}
    lede={page.lede}
    screenshot={PRODUCT_SCREENSHOTS[page.pageShotKey]}
    analyticsLocation="product_recap_sheet_import"
    sectionHeading="From the printed recap to scores on the board"
    sections={SECTIONS}
    secondaryTo="/pricing"
    secondaryLabel="Plans"
    structuredData={generateWebPageStructuredData({
      name: page.title,
      description: DESCRIPTION,
      url: "/bowling-tournament-recap-sheet-import",
      dateModified: "2026-11-04",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "Scoring", path: "/bowling-tournament-scoring" },
        {
          label: "Recap sheet import",
          path: "/bowling-tournament-recap-sheet-import",
        },
      ]),
    ]}
  />
);

export default BowlingTournamentRecapSheetImport;
